import { Component, OnDestroy, OnInit } from "@angular/core";
import {
    NbDialogService,
    NbMediaBreakpointsService,
    NbMenuService,
    NbSidebarService,
    NbThemeService,
} from "@nebular/theme";

import { UserData } from "../../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { WalletService } from "../../../services/wallet.service";
import { WalletConnectDialogComponent } from "../../../wallet-connect-dialog/wallet-connect-dialog.component";
import { ApiService } from "../../../services/api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MyTransactionsDialogComponent } from "../../../my-transactions-dialog/my-transactions-dialog.component";
import { UserTransactionsDialogComponent } from "../../../user-transactions-dialog/user-transactions-dialog.component";
import { DialogService } from "../../../services/dialogs.service";
import { CrowdsaleHelperService } from "../../../services/crowdsale-helper.service";
import { AddCrowdsaleComponent } from "../../../add-crowdsale/add-crowdsale.component";
@Component({
    selector: "ngx-header",
    styleUrls: ["./header.component.scss"],
    templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit, OnDestroy {
    private destroy$: Subject<void> = new Subject<void>();
    userPictureOnly: boolean = false;
    currentUserAddress: any;
    user: any;
    isConnected = false; // Variable to hold state of wheter wallet is connected.
    walletName = ""; // variable to hold the name of connected wallet when using WalletConnect
    isMetamask = false; // Variable to hide logout
    walletAddress = "";
    router: Router;

    contractAddress: string;

    selected = "";
    public staticPages;

    constructor(
        private sidebarService: NbSidebarService,
        private nbDialogService: NbDialogService,
        private menuService: NbMenuService,
        private themeService: NbThemeService,
        private userService: UserData,
        private breakpointService: NbMediaBreakpointsService,
        private _walletService: WalletService,
        private _apiService: ApiService,
        private _activatedRoute: ActivatedRoute,
        public crowdsaleHelperService: CrowdsaleHelperService,
        private _router: Router,
        private dialog: DialogService,
        private _dS: NbDialogService
    ) {
        this.router = _router;
    }
    ngOnInit() {
        this.getCurrentUserAddress();
        this.checkWallet();

        this.userService
            .getUsers()
            .pipe(takeUntil(this.destroy$))
            .subscribe((users: any) => (this.user = users.nick));

        const { xl } = this.breakpointService.getBreakpointsMap();
        this.themeService
            .onMediaQueryChange()
            .pipe(
                map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
                takeUntil(this.destroy$)
            )
            .subscribe(
                (isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl)
            );

        this._activatedRoute.params.subscribe((paramsData) => {
            if (paramsData.contractAddress) {
                this.contractAddress = paramsData.contractAddress;
            }
        });
        this.crowdsaleHelperService.savedCrowdsales$.next(
            JSON.parse(localStorage.getItem("myCrowdsales"))
        );
    }

    // Open Dialog box that contains buttons for metamask and wallet connect (Additional wallets can be implemented)
    openDialog() {
        this.nbDialogService.open(WalletConnectDialogComponent, {
            context: {
                // title:"Hello";
            },
        });
        // this._walletService.createConnection();
    }
    onViewMyTransactions() {
        this._dS.open(MyTransactionsDialogComponent, {
            closeOnBackdropClick: false,
            autoFocus: false,
            context: {
                walletAddress: this.walletAddress,
            },
        });
    }

    // TODO: Explore how to logout for each walelt
    logout = async () => {
        if (!this.isMetamask) {
            this._walletService.destroyConnectionWalletConnect();
            this.isConnected = false;
        }
    };

    // TODO: Connect wallet (Metamask)
    connectWallet = async () => {
        let initConn = await this._walletService.initConnection();
        if (!initConn) {
            this.isConnected == false;
        }
        // this._apiService.insertWhitelistedAddress(this.currentUserAddress).subscribe();
    };

    // TODO: Check wallet connection.
    checkWallet = async () => {
        this.isConnected = await this._walletService.checkWalletConnection();
        if (this.isConnected) {
            // this.walletName = (await this.getCurrentUserAddress()).substring(0, 10) +"...";
            this.walletAddress = await this.getCurrentUserAddress();
            this.walletName =
                "..." + (await this.getCurrentUserAddress()).slice(-8);
            this.selected = this.walletName;
            this.isMetamask = true;
            return true;
        } else {
            if (
                (await this._walletService.getCryptoComAddress()) != undefined
            ) {
                this.currentUserAddress =
                    await this._walletService.getCryptoComAddress();
                this.isConnected = true;
                this.isMetamask = false;
                // this.walletName = "..."+this.currentUserAddress.substring(0, 10);
                this.walletName = "..." + this.currentUserAddress[0].slice(-8);
                this.selected = this.walletName;
            }
        }
    };
    getCurrentUserAddress = async () => {
        if ((await this._walletService.getAddress()) === undefined) {
            return await this._walletService.getCryptoComAddress();
        } else {
            return await this._walletService.getAddress();
        }
    };

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    toggleSidebar(): boolean {
        this.sidebarService.toggle(true, "menu-sidebar");

        return false;
    }

    navigateHome() {
        if (this.contractAddress) {
            this.router.navigateByUrl("/" + this.contractAddress);
        } else {
            this.router.navigateByUrl("/");
        }
    }
    navigateTokenSale() {
        this.router.navigateByUrl("/tokenSale");
    }
    navigateBlog() {
        this.router.navigateByUrl("/" + this.contractAddress + "/blog");
    }
    recentTransactions() {
        this.dialogBase(UserTransactionsDialogComponent);
    }
    dialogBase(component: any) {
        this.dialog.open(component, (results: any, reload) => {
            console.log(reload);
        });
    }

    onChangeCrowdsale(value) {
        this._router.navigateByUrl("/" + value);
    }
    onAddCrowdsale() {
        this._dS.open(AddCrowdsaleComponent, { autoFocus: false });
    }

    onApplyForDemo() {
        this._router.navigate(["demo-application"]);
    }
}
